import Vue from "vue";
import router from "./router";
import store from "./vuex";

// HTTP请求
import http from "./api/http_v2";
Vue.prototype.axios = http.axios;

// 饿了么UI框架
import ElementUI from "element-ui";
Vue.use(ElementUI, { size: "mini" });

// 表格
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
Vue.use(VXETable)

// 图标
import "./assets/newicon/style.css";

// 图表插件
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;

// 生成二维码插件
import "./js/qrcodejs/qrcode.js";

// 页面加载进度条
import "nprogress/nprogress.css";
import NProgress from "nprogress";

// 复制文本插件
import VueClipboard from "vue-clipboard2";
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

// 图片懒加载
import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require("./assets/img/loading.gif"),
  loading: require("./assets/img/loading.gif"),
  attempt: 1,
});

// 鼠标悬浮加遮罩 落地页左侧组件使用
import VueHoverMask from "vue-hover-mask";
Vue.component(VueHoverMask.name, VueHoverMask);

// 项目Api封装
import api from "./api/index";
Vue.prototype.api = api;

// 项目公共属性
import Public from "./js/public.js";
Vue.prototype.public = Public;
import * as CommonJS from "./js/common.js";

// 项目过滤器
import * as filters from "./filter/index";
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

import * as directives from "./directive.js";
Object.keys(directives).forEach((key) => {
  Vue.directive(key, directives[key]);
});

// 刷新iframe 值无所谓
Vue.prototype.$ReloadIframe = 0;

// 引入项目模块
import projectModules from "./modules";
projectModules.forEach((item) => {
  // 注入模块
  Vue.use(item, { store, router });
});

import Bus from "./utils/bus"; // 引入bus，用于组件通信
Vue.use(Bus);

//通过路由全局钩子来判断用户是否登录。没有登陆跳转到登录页面
router.beforeEach(async (to, from, next) => {
  NProgress.start();
  let loginignore = [
    "/login",
    "/register",
    "/findbyphone",
    "/serviceTerms",
    "/privacyTerms",
    "/marketTerms",
    "/weixincallback",
  ];
  if (loginignore.indexOf(to.path) >= 0) {
    next();
    return false;
  }
  let crmClueId = CommonJS.getQueryString("crmClueId");
  let yhtCode = CommonJS.getQueryString("code");
  if (crmClueId) {
    // 友户通登录逻辑
    if (sessionStorage.mkYHTToken) {
      if (to.path == "/customerRecordList") {
        next();
      } else {
        next("/customerRecordList");
      }
      
    } else if (yhtCode) {
      // 友户通登录
      let res = await api.tenant.yhtLogin({
        code: yhtCode
      })
      if (res.flag == 0) {
        sessionStorage.setItem("mkYHTToken",res.data);
        if (to.path == "/customerRecordList") {
          next();
        } else {
          next("/customerRecordList");
        }
      } else {
        alert("服务异常，请刷新重试");
        return false;
      }
    } else {
      let mkUrl = window.location.protocol + "//"; // 协议
      mkUrl += window.location.hostname; //域名
      mkUrl += window.location.port ? ":" + window.location.port : ""; //端口
      mkUrl += window.location.pathname; //网页地址
      mkUrl += "?crmClueId=" + crmClueId;
      let loginUrl = 'https://c1.yonyoucloud.com/login?service=' + encodeURIComponent(mkUrl + '&sessionStrategy=ykj_third_sys_service_strategy');
      window.location.href ='https://euc.yonyoucloud.com/cas/login?sysid=diwork&multiCas=true&service=' +encodeURIComponent(loginUrl) + '&yht_hash=YHT-17436-17309-1650262907153';
    }
  } else if (sessionStorage.token == null) {
    next("/login");
  } else if (
    store.getters.getUser &&
    store.getters.getUser.hasOwnProperty("id") &&
    store.getters.getUser.id
  ) {
    // 已有用户信息
    next();
  } else {
    // 无用户信息，服务端获取
    let res = await api.tenant.info();
    if (res.flag == 0) {
      store.dispatch("changeloginstate", true);
      store.dispatch("user", res.data);
      next();
    } else {
      store.dispatch("changeloginstate", false);
      sessionStorage.removeItem("token");
      next("/login");
    }
  }
});

// 用于修复fixed_table的问题，从新设置fixed的高度
router.afterEach((to, from) => {
  NProgress.done();
});

import App from "./App.vue";
const vm = new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});
